import { User } from "@/common/types/User";

export const BrokerUsers = [
  {
    email: 'oct@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'k.schulz@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'terry@48bytesnorth.com',
    broker: 'LYNX'
  },
  {
    email: 'a.asante@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'p.bruns@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'a.ehrhardt@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'f.heyer@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'g.mayer@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'm.possner@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'd.jaeckel@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'l.borrmann@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'p.rohde@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'p.bodenbach@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 's.werner@lynxbroker.de',
    broker: 'LYNX'
  },
  {
    email: 'oct@captraderbroker.de',
    broker: 'CAP_TRADER'
  },
  {
    email: 'andreas.weiss@captrader.com',
    broker: 'CAP_TRADER'
  },
  {
    email: 'mauro.heller@captrader.com',
    broker: 'CAP_TRADER'
  },
  {
    email: 'oct@agorabroker.de',
    broker: 'AGORA'
  },
  {
    email: 'a.tehrani@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 'p.scibisz@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 'm.giese@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 'oct@saxobankbroker.de',
    broker: 'SAXO_BANK'
  },
  {
    email: 'superadmin@onelogic.de',
    broker: 'AGORA'
  },
  {
    email: '48bndevkonto@gmail.com',
    broker: 'LYNX'
  },
  {
    email: 'w.steinich@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 'm.nowatzki@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 's.bussewitz@agora-direct.de',
    broker: 'AGORA'
  },
  {
    email: 'm.zebisch@agora-direct.de',
    broker: 'AGORA'
  }
];

export function extractBrokerOfUser (user: User): string | null {
  const result = BrokerUsers.find(brokerUser => brokerUser.email === user.email);
  if (result) {
    return result.broker;
  }
  return null;
}